interface CookieBannerProps {
  onAccept: () => void
  onDecline: () => void
  darkMode?: boolean
}

export default function CookieBanner({ onAccept, onDecline, darkMode = false }: CookieBannerProps) {
  const bg = darkMode ? '#1e2730' : '#ffffff'
  const border = darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(196,206,214,0.8)'
  const textMuted = darkMode ? '#a0aab3' : '#4a5560'
  const textMain = darkMode ? '#e0eaf2' : '#1d242b'

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Cookie and tracking consent"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: 'min(580px, calc(100vw - 32px))',
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 16,
        padding: '20px 24px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        fontFamily: "'Space Grotesk', 'Helvetica Neue', Arial, sans-serif",
      }}
    >
      <div>
        <p style={{ fontWeight: 600, fontSize: '0.95rem', color: textMain, margin: '0 0 6px' }}>
          Cookies &amp; Tracking
        </p>
        <p style={{ fontSize: '0.84rem', color: textMuted, lineHeight: 1.65, margin: 0 }}>
          We use the Meta (Facebook) Pixel to measure advertising effectiveness. This may set
          cookies and collect browsing data.{' '}
          <a
            href="https://artistascend.app/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#2c7b6a', textDecoration: 'none' }}
          >
            Privacy Policy
          </a>
        </p>
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button
          onClick={onAccept}
          style={{
            flex: '1 1 120px',
            padding: '9px 20px',
            borderRadius: 999,
            border: 'none',
            background: '#2c7b6a',
            color: '#ffffff',
            fontWeight: 600,
            fontSize: '0.875rem',
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Accept
        </button>
        <button
          onClick={onDecline}
          style={{
            flex: '1 1 120px',
            padding: '9px 20px',
            borderRadius: 999,
            border: `1px solid ${border}`,
            background: 'transparent',
            color: textMuted,
            fontWeight: 500,
            fontSize: '0.875rem',
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Decline
        </button>
      </div>
    </div>
  )
}
